import { useEffect } from 'react';
import { useOrganization } from './useOrganization';
import { useMultiAccountStore } from '../../auth/stores/multiAccountStore';

/**
 * Syncs the current organisation name to the stored account in localStorage.
 * This ensures the account list always shows the correct organisation name.
 *
 * Should be called once when the user is authenticated.
 */
export function useOrganizationSync() {
  const { data: orgData } = useOrganization();

  useEffect(() => {
    const currentOrgName = orgData?.currentOrganisation?.name;
    if (!currentOrgName) return;

    // Access store methods directly to avoid subscription-based re-renders
    const { getCurrentAccount, updateAccount } =
      useMultiAccountStore.getState();
    const currentAccount = getCurrentAccount();

    if (
      currentAccount &&
      currentAccount.currentOrganisationName !== currentOrgName
    ) {
      updateAccount(currentAccount.email, {
        currentOrganisationName: currentOrgName,
      });
    }
  }, [orgData?.currentOrganisation?.name]);
}
